import styled from 'styled-components';

export const Content = styled.div`
  /* height: 430px; */
  max-height: 65.4ch;
  min-height: 60px;
  overflow-y: auto;
  padding: 10px;
  background-color: #10151a;
  border: 1px solid #2c353d;
  border-radius: 10px;
  font-size: 12px;
  line-height: 1.2;
  transition: opacity 0.15s ease-in-out;
  &.loading {
    opacity: 0.5;
  }
  img {
    line-height: 1;
    border-radius: 8px;
    max-width: 100%;
    height: auto;
    width: 100%;
    padding: 0;
    margin: 0;
  }
`;
